/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  GetApiLocationList200,
  GetApiLocationListParams,
  LocationApiResource,
  LocationRequest,
  NotFoundErrorResponse,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiLocationListResponse200 = {
  data: GetApiLocationList200
  status: 200
}

export type getApiLocationListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiLocationListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiLocationListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiLocationListResponseSuccess = (getApiLocationListResponse200) & {
  headers: Headers;
};
export type getApiLocationListResponseError = (getApiLocationListResponse400 | getApiLocationListResponse401 | getApiLocationListResponse403) & {
  headers: Headers;
};

export type getApiLocationListResponse = (getApiLocationListResponseSuccess | getApiLocationListResponseError)

export const getGetApiLocationListUrl = (params?: GetApiLocationListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/locations?${stringifiedParams}` : `/api/locations`
}

export const getApiLocationList = async (params?: GetApiLocationListParams, options?: RequestInit): Promise<getApiLocationListResponse> => {
  
  return customFetch<getApiLocationListResponse>(getGetApiLocationListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type postApiLocationCreateResponse201 = {
  data: LocationApiResource
  status: 201
}

export type postApiLocationCreateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiLocationCreateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiLocationCreateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type postApiLocationCreateResponseSuccess = (postApiLocationCreateResponse201) & {
  headers: Headers;
};
export type postApiLocationCreateResponseError = (postApiLocationCreateResponse400 | postApiLocationCreateResponse401 | postApiLocationCreateResponse403) & {
  headers: Headers;
};

export type postApiLocationCreateResponse = (postApiLocationCreateResponseSuccess | postApiLocationCreateResponseError)

export const getPostApiLocationCreateUrl = () => {


  

  return `/api/locations`
}

export const postApiLocationCreate = async (locationRequest: LocationRequest, options?: RequestInit): Promise<postApiLocationCreateResponse> => {
  
  return customFetch<postApiLocationCreateResponse>(getPostApiLocationCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      locationRequest,)
  }
);}


export type getApiLocationGetResponse200 = {
  data: LocationApiResource
  status: 200
}

export type getApiLocationGetResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiLocationGetResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiLocationGetResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiLocationGetResponseSuccess = (getApiLocationGetResponse200) & {
  headers: Headers;
};
export type getApiLocationGetResponseError = (getApiLocationGetResponse401 | getApiLocationGetResponse403 | getApiLocationGetResponse404) & {
  headers: Headers;
};

export type getApiLocationGetResponse = (getApiLocationGetResponseSuccess | getApiLocationGetResponseError)

export const getGetApiLocationGetUrl = (id: string,) => {


  

  return `/api/locations/${id}`
}

export const getApiLocationGet = async (id: string, options?: RequestInit): Promise<getApiLocationGetResponse> => {
  
  return customFetch<getApiLocationGetResponse>(getGetApiLocationGetUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type putApiLocationUpdateResponse200 = {
  data: LocationApiResource
  status: 200
}

export type putApiLocationUpdateResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiLocationUpdateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiLocationUpdateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiLocationUpdateResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type putApiLocationUpdateResponseSuccess = (putApiLocationUpdateResponse200) & {
  headers: Headers;
};
export type putApiLocationUpdateResponseError = (putApiLocationUpdateResponse400 | putApiLocationUpdateResponse401 | putApiLocationUpdateResponse403 | putApiLocationUpdateResponse404) & {
  headers: Headers;
};

export type putApiLocationUpdateResponse = (putApiLocationUpdateResponseSuccess | putApiLocationUpdateResponseError)

export const getPutApiLocationUpdateUrl = (id: string,) => {


  

  return `/api/locations/${id}`
}

export const putApiLocationUpdate = async (id: string,
    locationRequest: LocationRequest, options?: RequestInit): Promise<putApiLocationUpdateResponse> => {
  
  return customFetch<putApiLocationUpdateResponse>(getPutApiLocationUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      locationRequest,)
  }
);}


export type deleteApiLocationDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteApiLocationDeleteResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiLocationDeleteResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiLocationDeleteResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiLocationDeleteResponseSuccess = (deleteApiLocationDeleteResponse204) & {
  headers: Headers;
};
export type deleteApiLocationDeleteResponseError = (deleteApiLocationDeleteResponse401 | deleteApiLocationDeleteResponse403 | deleteApiLocationDeleteResponse404) & {
  headers: Headers;
};

export type deleteApiLocationDeleteResponse = (deleteApiLocationDeleteResponseSuccess | deleteApiLocationDeleteResponseError)

export const getDeleteApiLocationDeleteUrl = (id: string,) => {


  

  return `/api/locations/${id}`
}

export const deleteApiLocationDelete = async (id: string, options?: RequestInit): Promise<deleteApiLocationDeleteResponse> => {
  
  return customFetch<deleteApiLocationDeleteResponse>(getDeleteApiLocationDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


